module.exports = __webpack_public_path__ + "assets/img/title-302ed5be.png";